"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxComponent = exports.Image = exports.ImageBox = exports.Answer = exports.TextBox = exports.Box = exports.Container = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: ${({ direction }) => direction || 'row'};
`;
exports.Box = styled_components_1.default.div `
  display: flex;
  border-radius: 12px;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  gap: 20px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 9px;
    padding: 10px;
  }
`;
exports.TextBox = styled_components_1.default.div `
  flex-grow: 1;
  text-align: ${({ isRevert }) => (isRevert ? 'right' : 'left')};
  font-size: clamp(16px, 3vw, 80px);
  font-weight: bold;
  font-family: Phenomena;
  color: #6e76fb;
`;
exports.Answer = styled_components_1.default.span `
  color: ${({ isCorrect }) => (isCorrect ? '#3CB949' : '#FE2B45')};
  font-weight: bold;
  text-decoration: underline;
  display: inline-block;

  &::first-letter {
    text-transform: ${({ capitalize }) => (capitalize ? 'uppercase' : 'unset')};
  }
`;
exports.ImageBox = styled_components_1.default.div `
  display: flex;
  justify-content: end;
  align-items: end;
  max-width: 100%;
`;
exports.Image = styled_components_1.default.img `
  width: 95%;
  height: auto;
  max-width: 350px;
`;
const BoxComponent = ({ list, isRevert, withRightWord, correctSayedWord, isDisinhibition, customAnswer, }) => {
    return (react_1.default.createElement(exports.Container, null, list.map((item, index) => {
        var _a;
        const partsForDisinhibition = (_a = item === null || item === void 0 ? void 0 : item.content) === null || _a === void 0 ? void 0 : _a.split('*');
        const imageSrc = (item === null || item === void 0 ? void 0 : item.hint) && item.hint.startsWith('http') ? item.hint : '/images/placeholder.png';
        return (react_1.default.createElement(exports.Box, { key: index }, isRevert ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(exports.ImageBox, null,
                react_1.default.createElement(exports.Image, { src: imageSrc, alt: `Image ${index + 1}` })),
            react_1.default.createElement(exports.TextBox, { isRevert: isRevert }, isDisinhibition ? (react_1.default.createElement(react_1.default.Fragment, null, partsForDisinhibition === null || partsForDisinhibition === void 0 ? void 0 :
                partsForDisinhibition[0],
                typeof (item === null || item === void 0 ? void 0 : item.isCorrect) === 'boolean' ? (react_1.default.createElement(exports.Answer, { isCorrect: item === null || item === void 0 ? void 0 : item.isCorrect }, customAnswer || (item === null || item === void 0 ? void 0 : item.right_word))) : ('________'), partsForDisinhibition === null || partsForDisinhibition === void 0 ? void 0 :
                partsForDisinhibition[1])) : (react_1.default.createElement(react_1.default.Fragment, null,
                typeof (item === null || item === void 0 ? void 0 : item.isCorrect) !== 'boolean' ? ('............') : (react_1.default.createElement(exports.Answer, { isCorrect: correctSayedWord ? correctSayedWord : item === null || item === void 0 ? void 0 : item.isCorrect, capitalize: true }, item === null || item === void 0 ? void 0 : item.answer)),
                ' ',
                "- ", item === null || item === void 0 ? void 0 :
                item.question))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(exports.TextBox, { wrapWord: withRightWord }, isDisinhibition ? (react_1.default.createElement(react_1.default.Fragment, null, partsForDisinhibition === null || partsForDisinhibition === void 0 ? void 0 :
                partsForDisinhibition[0],
                typeof (item === null || item === void 0 ? void 0 : item.isCorrect) === 'boolean' ? (react_1.default.createElement(exports.Answer, { isCorrect: item === null || item === void 0 ? void 0 : item.isCorrect, capitalize: !(partsForDisinhibition === null || partsForDisinhibition === void 0 ? void 0 : partsForDisinhibition[0]) }, customAnswer || (item === null || item === void 0 ? void 0 : item.right_word))) : ('________'), partsForDisinhibition === null || partsForDisinhibition === void 0 ? void 0 :
                partsForDisinhibition[1])) : (react_1.default.createElement(react_1.default.Fragment, null, item === null || item === void 0 ? void 0 :
                item.content,
                " -",
                ' ',
                typeof (item === null || item === void 0 ? void 0 : item.isCorrect) !== 'boolean' ? ('............') : (react_1.default.createElement(exports.Answer, { isCorrect: item === null || item === void 0 ? void 0 : item.isCorrect, capitalize: true }, correctSayedWord || (item === null || item === void 0 ? void 0 : item.right_word) || (item === null || item === void 0 ? void 0 : item.answer)))))),
            react_1.default.createElement(exports.ImageBox, null,
                react_1.default.createElement(exports.Image, { src: imageSrc, alt: `Image ${index + 1}` }))))));
    })));
};
exports.BoxComponent = BoxComponent;
exports.default = exports.BoxComponent;
